const BASE_OPTIONS = {
    showHideTransition: 'fade',
    allowToastClose: true,
    stack: false,
    position: 'top-center',
    textAlign: 'center',
    loader: false,
    hideAfter: false
};

export function Error(text, hideAfter = false) {
    $.toast({
        ...BASE_OPTIONS,
        text: `<i class="fal fa-circle-exclamation toast-icon" aria-hidden="true"></i><span class="toast-text">${text}</span>`,
        bgColor: '#A0272B',
        textColor: '#ffffff',
        hideAfter: hideAfter
    });
}

export function Warning(text, hideAfter = 5000) {
    $.toast({
        ...BASE_OPTIONS,
        text: `<i class="fal fa-triangle-exclamation toast-icon" aria-hidden="true"></i><span class="toast-text">${text}</span>`,
        bgColor: '#B54708',
        textColor: '#ffffff',
        hideAfter: hideAfter
    });
}

export function Info(text) {
    $.toast({
        ...BASE_OPTIONS,
        text: `<i class="fal fa-circle-info toast-icon" aria-hidden="true"></i><span class="toast-text">${text}</span>`,
        bgColor: '#00778B',
        textColor: '#ffffff',
        hideAfter: 5000
    });
}

export function Success(text) {
    $.toast({
        ...BASE_OPTIONS,
        text: `<i class="fal fa-circle-check toast-icon" aria-hidden="true"></i><span class="toast-text">${text}</span>`,
        bgColor: '#62A752',
        textColor: '#ffffff',
        hideAfter: 5000
    });
}
